import React, { useState, useEffect } from "react";
import { fetchOrganizationEmployee } from "../../../Apis/Employee-api";
import { fetchOrganizationEmployeeAddressTypes } from "../../../Apis/EmployeeAddressType-api";
import { fetchcities } from "../../../Apis/OrganizationLocation";
import { fetchOrganizationResidentialOwnerType } from "../../../Apis/ResidentialOwnershipType-api";
import {
  Box,
  Button,
  Grid,
  Paper,
  MenuItem,
  TextField,
  Checkbox,
  CircularProgress,
  InputLabel,
  Select,
  FormHelperText,
  FormControl,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  FormGroup,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate, useParams } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import useEmployeeDataStore from "../../../Zustand/Store/useEmployeeDataStore";

function EmployeeAddressForm({ mode, employeeId, singleForm }) {
  const { userData } = useAuthStore();
  const org = userData?.organization;
  const { id } = useParams();

  const {
    setAddressData,
    Address,
    getDropdowndata,
    AddressErrors,
    DropDownData,
    addAddress,
    removeAddress,
  } = useEmployeeDataStore();

  const [expanded, setExpanded] = useState("Address 1");

  const handleChangeAccoridan = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : "");
  };

  const [loading, setLoading] = useState(mode === "edit");
  const [btnLoading, setbtnLoading] = useState(false);
  const [cityOptions, setCity] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [employeeAddressType, setEmployeeAddressType] = useState([]);
  const [residentailtype, setResidentialType] = useState([]);

  let navigate = useNavigate();

  useEffect(() => {
    {
      fetchOrganizationEmployeeAddressTypes(org.organization_id)
        .then((data) => {
          setEmployeeAddressType(data?.addresstype?.data);
        })
        .catch((err) => {
          console.log("err is : ", err);
        });
    }
  }, []);

  useEffect(() => {
    if (inputValue?.length < 2) return;
    fetchcities(inputValue)
      .then((data) => {
        setCity(data.cities);
      })
      .catch((err) => {
        console.error("Error fetching cities:", err);
      });
  }, [inputValue]);

  useEffect(() => {
    {
      fetchOrganizationResidentialOwnerType(org.organization_id)
        .then((data) => {
          setResidentialType(data.residentialtype.data);
        })
        .catch((err) => {
          console.log("err is : ", err);
        });
    }
  }, []);

  const handleChange = (e, idx) => {
    const { name, value } = e.target;

    setAddressData(name, value, idx);
  };

  const addressSections = Address?.map((item, id) => ({
    name: `Address ${id + 1}`,
    mainData: item,
  }));

  const renderAddressFields = (section, idx) => (
    <Grid container spacing={2}>
      <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
        <FormControl
          fullWidth
          error={
            !!AddressErrors?.[idx]?.organization_employee_address_type_id
          }
        >
          <InputLabel id={`employee-address-type-label-${idx}`}>
            Employee Address Type
          </InputLabel>
          <Select
            disabled={mode === "view"}
            labelId={`employee-address-type-label-${idx}`}
            name="organization_employee_address_type_id"
            value={
              section?.mainData?.organization_employee_address_type_id || ""
            }
            label="Employee Address Type"
            onChange={(e) => handleChange(e, idx)}
          >
            {employeeAddressType?.map((option) => (
              <MenuItem
                key={option?.organization_employee_address_type_id}
                value={option?.organization_employee_address_type_id}
              >
                {option?.employee_address_type_name}
              </MenuItem>
            ))}
          </Select>
          {AddressErrors?.[idx]?.organization_employee_address_type_id && (
            <FormHelperText>
              {AddressErrors?.[idx]?.organization_employee_address_type_id}
            </FormHelperText>
          )}
        </FormControl>

        <FormControl
          disabled={mode === "view"}
          fullWidth
          error={
            !!AddressErrors?.[idx]
              ?.organization_residential_ownership_type_id
          }
        >
          <InputLabel id={`employee-ownership-type-label-${idx}`}>
            Residential Ownership Type
          </InputLabel>
          <Select
            labelId={`employee-ownership-type-label-${idx}`}
            name="organization_residential_ownership_type_id"
            value={
              section?.mainData
                ?.organization_residential_ownership_type_id || ""
            }
            label="Residential Ownership Type"
            onChange={(e) => handleChange(e, idx)}
          >
            {residentailtype?.map((option) => (
              <MenuItem
                key={option?.organization_residential_ownership_type_id}
                value={option?.organization_residential_ownership_type_id}
              >
                {option?.residential_ownership_type_name}
              </MenuItem>
            ))}
          </Select>
          {AddressErrors?.[idx]
            ?.organization_residential_ownership_type_id && (
            <FormHelperText>
              {
                AddressErrors?.[idx]
                  ?.organization_residential_ownership_type_id
              }
            </FormHelperText>
          )}
        </FormControl>

        <TextField
          disabled={mode === "view"}
          fullWidth
          label="Postal Code"
          name="postal_code"
          value={section?.mainData?.postal_code || ""}
          onChange={(e) => handleChange(e, idx)}
          error={!!AddressErrors?.[idx]?.postal_code}
          helperText={AddressErrors?.[idx]?.postal_code}
          inputProps={{ maxLength: 20 }}
        />
      </Box>

      <Box sx={{ display: "flex", gap: 2, width: "100%", mt: 2 }}>
        <TextField
          disabled={mode === "view"}
          fullWidth
          required
          label="Address Line 1"
          name="address_line1"
          value={section?.mainData?.address_line1 || ""}
          onChange={(e) => handleChange(e, idx)}
          error={!!AddressErrors?.[idx]?.address_line1}
          helperText={AddressErrors?.[idx]?.address_line1}
          inputProps={{ maxLength: 100 }}
        />
        <TextField
          disabled={mode === "view"}
          fullWidth
          label="Address Line 2"
          name="address_line2"
          value={section?.mainData?.address_line2 || ""}
          onChange={(e) => handleChange(e, idx)}
          error={!!AddressErrors?.[idx]?.address_line2}
          helperText={AddressErrors?.[idx]?.address_line2}
          inputProps={{ maxLength: 100 }}
        />
        {!singleForm && (
          <TextField
            disabled={mode === "view"}
            fullWidth
            label="Address Line 3"
            name="address_line3"
            value={section?.mainData?.address_line3 || ""}
            onChange={(e) => handleChange(e, idx)}
            error={!!AddressErrors?.[idx]?.address_line3}
            helperText={AddressErrors?.[idx]?.address_line3}
            inputProps={{ maxLength: 100 }}
          />
        )}
      </Box>

      <Box sx={{ display: "flex", gap: 2, width: singleForm ? "33%" : "33%", mt: 2 }}>
        <Autocomplete
          disabled={mode === "view"}
          options={cityOptions}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.city_name
          }
          fullWidth
          value={section?.mainData?.city || null}
          onChange={(event, newValue) => {
            setAddressData("general_city_id", newValue?.general_city_id, idx);
            setAddressData("city", newValue || "", idx);
          }}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          isOptionEqualToValue={(option, value) =>
            option?.general_city_id === value?.general_city_id
          }
          renderInput={(params) => (
            <TextField
              {...params}
              required
              label="City"
              error={!!AddressErrors?.[idx]?.general_city_id}
              helperText={AddressErrors?.[idx]?.general_city_id}
            />
          )}
        />
      </Box>
    </Grid>
  );

  return (
    <Box px={singleForm ? 0 : 4}>
      <Box>
        {singleForm
          ? addressSections?.map((section, idx) => (
              <Box key={section.name} sx={{ mb: idx < Address.length - 1 ? 3 : 0 }}>
                {Address.length > 1 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                      {section.name}
                    </Typography>
                    {idx !== 0 && (
                      <DeleteOutlineIcon
                        onClick={() => removeAddress(idx)}
                        sx={{ color: "error.main", cursor: "pointer" }}
                      />
                    )}
                  </Box>
                )}
                {renderAddressFields(section, idx)}
              </Box>
            ))
          : addressSections?.map((section, idx) => (
              <Accordion
                sx={{ mb: 2 }}
                key={section.name}
                expanded={expanded === section.name}
                onChange={handleChangeAccoridan(section.name)}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "15px", fontWeight: "bold" }}
                    >
                      {section.name}
                    </Typography>
                    {idx !== 0 && (
                      <DeleteOutlineIcon
                        onClick={(e) => {
                          e.stopPropagation();
                          removeAddress(idx);
                        }}
                        sx={{ color: "error.main", ml: 2 }}
                      />
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  {expanded === section.name && (
                    <Paper elevation={4} sx={{ p: 3 }}>
                      {renderAddressFields(section, idx)}
                    </Paper>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}

        {!singleForm && (
          <Button
            disabled={mode === "view"}
            style={{ marginTop: 9 }}
            variant="contained"
            onClick={() => {
              setExpanded(`Address ${Address?.length + 1}`);
              addAddress();
            }}
          >
            Add More
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default EmployeeAddressForm;
